export const testimonialsData = {
  header: {
    badge: {
      text: "Client Reviews",
      icon: "QuoteIcon"
    },
    title: "What Our Clients Say",
    description: "Hear what our satisfied clients are saying about our professional home inspection services!"
  },
  scrollHint: {
    text: "Swipe to read more testimonials",
    icon: "SwipeIcon"
  },
  testimonials: [
    { 
      feedback: 'I had the pleasure of working with Nikita Mejari and the SnagEasy team for a thorough property inspection at the Marathon Nexzone property. Nikita’s attention to detail throughout the inspection was exceptional. The comprehensive report provided was clear, well-structured, and covered every aspect of the property meticulously. The entire SnagEasy team demonstrated great professionalism and dedication, which gave me confidence in understanding the true condition of the property. I highly recommend Nikita Mejari and N S Mountains Home inspection servicesfor anyone seeking a reliable and detailed property inspection service.', 
      name: 'Ms Sarita Gupta',
      rating: 5,
      location: 'Mumbai, Maharashtra'
    },
    { 
      feedback: 'I had a fantastic experience with N S Mountains. From start to finish, their team was professional, thorough, and incredibly knowledgeable. The inspector arrived on time, explained the process clearly, and took the time to answer all my questions. The inspection report was detailed, easy to understand, and included helpful photos and recommendations. Thanks to their keen eye, I was able to make an informed decision about my property. I highly recommend them to anyone looking for a reliable and trustworthy home inspection service!', 
      name: 'Ms Shivani Patil',
      rating: 5,
      location: 'Bangalore, Karnataka'
    },
    { 
      feedback: 'Fantastic experience. I have come across many services but NS Mountains are very professional and their entire inspection team provided accurate reports with photographs and ratings. Their services are highly recommended.', 
      name: 'Mr Vinayak Jadhav',
      rating: 5,
      location: 'Mumbai, Maharashtra'
    },
    { 
      feedback: 'Team did a great job. I am totally satisfied with the service. I was very apprehensive before taking the services but now its worth every penny. Special kudos to Nikita. She took a lot of pains explaining the report for 1hr along with resolution. Also took the follow-ups until problem gets resolved. Very much pocket friendly. Dont think much just go for it.', 
      name: 'Mr Rohit Raina',
      rating: 5,
      location: 'Pune, Maharashtra'
    },
    { 
      feedback: 'I recently had the pleasure of working with N S Mountains - Home Inspection Services, and I am thoroughly impressed with their professionalism and expertise. The inspector was incredibly thorough, leaving no stone unturned during the inspection. Their attention to detail was exceptional, and they patiently addressed all my concerns and inquiries. The inspection report was comprehensive and easy to understand, giving me a clear picture of the propertys condition. I highly recommend N S Mountains - Home Inspection Services to anyone seeking a reliable and meticulous home inspection. They exceeded my expectations, and I am grateful for their top-notch service!', 
      name: 'Mr Ashish Bhujadi',
      rating: 5,
      location: 'Pune, Maharashtra'
    },
    { 
      feedback: 'Qualified team, easy process, pocket friendly amount if we compare with property value. Detailed inspection report, hence easy to understand the highlighted defect points. Overall good experience.', 
      name: 'Ms Pradnya Gawkhadkar',
      rating: 5,
      location: 'Bangalore, Karnataka'
    },
    { 
      feedback: 'The report provided by team have highlighted all the issues observed in the flat. Thanks', 
      name: 'Ms Kartavya Pawar',
      rating: 5,
      location: 'Mumbai, Maharashtra'
    },
    { 
      feedback: 'Fantastic experience. I have come across many services but NS Mountains are very professional and their entire inspection team provided accurate reports with photographs and ratings. Their services are highly recommended.', 
      name: 'Mr Vinayak Jadhav',
      rating: 5,
      location: 'Mumbai, Maharashtra'
    }
  ]
};
